import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
import { airportActions } from '../_actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/fontawesome-free-solid'

class DeleteAirportModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
    this.deleteAirport = this.deleteAirport.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  deleteAirport() {
    console.log("DELETE");
    console.log(this.props.airport_id);
    this.props.delete(this.props.airport_id);
    this.toggle();
  }

  render() {
    return (
      <div>
        <Button color="danger" className="full-width" onClick={this.toggle}><FontAwesomeIcon icon={faTimes} color="white" size="lg" /></Button>
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader>Supprimer un aéroport</ModalHeader>
          <ModalBody>
            <div>Êtes-vous certains de vouloir supprimer cet aéroport?</div>
          </ModalBody>
          <ModalFooter>
            <Row>
              <Col>
                <Button color="danger" onClick={this.deleteAirport}>Supprimer</Button>
              </Col>
              <Col xs="6" className="text-center" >
                <Button color="secondary" onClick={this.toggle}>Annuler</Button>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
    return {};
}

const mapDispatchToProps = (dispatch) => {
  return {
    delete: (airport_id) => {
      dispatch(airportActions.delete(airport_id))
    }
  }
}

const connectedDeleteAirportModal = connect(mapStateToProps, mapDispatchToProps)(DeleteAirportModal);
export { connectedDeleteAirportModal as DeleteAirportModal };
